import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { IBodyPart } from 'src/app/interfaces/SelfReport/IBodyPart';
import { bodyMaleBack } from './body/body-male-back';
import { bodyMaleFront } from './body/body-male-front';
import { bodyFemaleBack } from './body/body-female-back';
import { bodyFemaleFront } from './body/body-female-front';
import { IPatientDetailed } from 'src/app/interfaces/Detailed/IPatientDetailed';
import { PatientService } from 'src/app/services/patient.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-body-highlighter',
  templateUrl: './body-highlighter.component.html',
  styleUrls: ['./body-highlighter.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BodyHighlighterComponent {
  @Input() side: 'front' | 'back' = 'front';
  @Input() frontSelectedParts: string[] = [];
  @Input() backSelectedParts: string[] = [];
  // @Output() partClicked = new EventEmitter<string>();

  private destroy$ = new Subject<void>();

  patientInfo?: IPatientDetailed;

  constructor(private readonly patientService: PatientService) {
    this.patientService.patientInfoSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((patientInfo?: IPatientDetailed) => {
        this.patientInfo = patientInfo;
      });
  }

  get frontBodyParts(): IBodyPart[] {
    return this.patientInfo?.gender?.toLowerCase() == 'female'
      ? bodyFemaleFront
      : bodyMaleFront;
    // return this.side === 'front' ? bodyFront : bodyBack;
  }

  get backBodyParts(): IBodyPart[] {
    return this.patientInfo?.gender?.toLowerCase() == 'female'
      ? bodyFemaleBack
      : bodyMaleBack;
    // return this.side === 'front' ? bodyFront : bodyBack;
  }

  isFrontSelected(slug: string): boolean {
    return this.frontSelectedParts.includes(slug);
  }

  isBackSelected(slug: string): boolean {
    return this.backSelectedParts.includes(slug);
  }

  getPaths(part: IBodyPart): string[] {
    const left = part.path?.left ?? [];
    const right = part.path?.right ?? [];
    const common = part.path?.common ?? [];
    return [...left, ...right, ...common];
  }

  // onPathClick(slug: string): void {
  //   this.partClicked.emit(slug);
  // }

  ngOnDestroy() {
    // Unsubscribe from observables
    this.destroy$.next();
    this.destroy$.complete();
  }
}
